module.exports = __webpack_public_path__ + "assets/img/store_state_default.a5f6bff5.jpg";